const doc = [({"zh_tw":({"adminConstantHotelChildrenSettingMealType":({"included":"包含", "notIncluded":"沒有任何", "sameAsAdult":"和成年人一樣"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;